export function getSelectedCountry(state) {
  return state.selectedCountry;
}
